import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const Select = styled(Box).attrs(() => ({ as: "button", type: "button" }))`
    cursor: pointer;
`;
const SelectCaret = styled("span")`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 ${spacing("md")};
    display: flex;
    place-items: center;
    pointer-events: none;
`;

export { Select, SelectCaret };
//# sourceMappingURL=styled.es.js.map
